import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from 'styled-components';

const ChinaIconDiv = styled.div`
`


const ChinaIcon = ({width}) => { 
  const icon = useStaticQuery(graphql`
    query {
      chinaIcon: file(relativePath: { eq: "china.png" }) {
        childImageSharp {
          fixed(width: 25, , quality: 10) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return (
    <ChinaIconDiv style={{width: `${width}px`}}>
        <Img fixed={icon.chinaIcon.childImageSharp.fixed} />
    </ChinaIconDiv>
  )
}

export default ChinaIcon
